import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { RouterModule } from '@angular/router';
import { BannerCarouselComponent } from './carousels/banner-carousel/banner-carousel.component';
import { FreemodeCarouselComponent } from './carousels/freemode-carousel/freemode-carousel.component';
import { JourneySelectPlusCardComponent } from './carousels/journey-select-plus-card/journey-select-plus-card.component';
import { CircleCategoryCarouselComponent } from './carousels/circle-category-carousel/circle-category-carousel.component';
import { EventsCardComponent } from './events-card/events-card.component';
import { SimilarEventsCarouselComponent } from './carousels/similar-events-carousel/similar-events-carousel.component';
import { ProductGridItemComponent } from './product-grid-item/product-grid-item.component';
import { SingleBannerComponent } from './single-banner/single-banner.component';
import { TermsModalComponent } from './modals/terms-modal/terms-modal.component';
import { TermsConditionsModalComponent } from './modals/terms-conditions-modal/terms-conditions-modal.component';
import { PrivacyPolicyModalComponent } from './modals/privacy-policy-modal/privacy-policy-modal.component';
import { SubmitSuccessComponent } from './page-status/submit-success/submit-success.component';
import { ReactiveFormsModule } from '@angular/forms';
import { NoBirthdayComponent } from './page-status/no-birthday/no-birthday/no-birthday.component';
import { CouponCardComponent } from './coupon-card/coupon-card.component';
import { BenefitsModalComponent } from './modals/benefits-modal/benefits-modal.component';
import { PriviligesModalComponent } from './modals/priviliges-modal/priviliges-modal.component';
import { UserCardComponent } from './user-card/user-card.component';
import { FlightCardComponent } from './flight-card/flight-card.component';
import { DynamicFormComponent } from './dynamic-form/dynamic-form.component';
import { FlightDepartureComponent } from './flight-departure/flight-departure.component';
import { FlightArrivalComponent } from './flight-arrival/flight-arrival.component';
import { ProductCardListComponent } from './product-card-list/product-card-list.component';
import { AutocheckoutFormComponent } from './autocheckout-form/autocheckout-form.component';
import { NoDataComponent } from './page-status/no-data/no-data.component';
import { CountryCodeModalComponent } from './modals/country-code-modal/country-code-modal.component';

import { FlightListCardComponent } from './flight-list-card/flight-list-card.component';
import { HeroBannerComponent } from './airport/hero-banner/hero-banner.component';
import { IconButtonsGridComponent } from './airport/icon-buttons-grid/icon-buttons-grid.component';
import { ProductCarouselComponent } from './airport/product-carousel/product-carousel.component';
import { BannerGridComponent } from './banner-grid/banner-grid.component';
import { SupportWidgetComponent } from './support-widget/support-widget.component';
import { SmartHeroComponent } from './home/smart-hero/smart-hero.component';
import { ButtonsGridComponent } from './home/buttons-grid/buttons-grid.component';
import { AddVoucherComponent } from './add-voucher/add-voucher.component';
import { FormsModule } from '@angular/forms';
import { RetailCarouselComponent } from './home/retail-carousel/retail-carousel.component';
import { BookingItemComponent } from './booking-item/booking-item.component';
import { DynamicFormModalComponent } from './modals/dynamic-form-modal/dynamic-form-modal.component';
import { SafeAreaHeaderComponent } from './safe-area-header/safe-area-header.component';
import { GenericErrorComponent } from './page-status/generic-error/generic-error.component';
import { NoNetworkComponent } from './page-status/no-network/no-network.component';
import { ComingSoonComponent } from './page-status/coming-soon/coming-soon.component';
import { MessageModalComponent } from './modals/message-modal/message-modal.component';
import { RetailListCardComponent } from './retail-list-card/retail-list-card.component';
import { OfferCardComponent } from './offer-card/offer-card.component';
import { OrderItemComponent } from './order-item/order-item.component';
import { FilterModalComponent } from './modals/filter-modal/filter-modal.component';
import { BarcodeScannerModalComponent } from './modals/barcode-scanner-modal/barcode-scanner-modal.component';
import { UpgradeMembershipComponent } from './upgrade-membership/upgrade-membership.component';
import { InlineGenericErrorComponent } from './page-status/inline-generic-error/inline-generic-error.component';
import { CityListComponent } from './city-list/city-list.component';
import { SelectCountryModalComponent } from './modals/select-country-modal/select-country-modal.component';
import { GenericModalComponent } from './modals/generic-modal/generic-modal.component';
import { UserGuestListComponent } from './user-guest-list/user-guest-list.component';
import { OrderDetailsComponent } from './order-details-component/order-details.component';
import { SmartDatePipe } from 'src/app/pipes/smart-date.pipe';
import { Nl2brPipe } from 'src/app/pipes/nl2br.pipe';
import { SafeHtmlPipe } from 'src/app/pipes/safe-html.pipe';
import { DutyfreeCurrencyPipe } from 'src/app/pipes/dutyfree-currency.pipe';
import { BookingHistoryItemComponent } from './booking-history-item/booking-history-item.component';
import { BenefitCardComponent } from './benefit-card/benefit-card.component';
import { TranslationComponent } from './translation/translation.component';
import { TranslateModule } from '@ngx-translate/core';
import { CounterButtonsComponent } from './counter-buttons/counter-buttons.component';
import { HeaderComponentComponent } from './header-component/header-component.component';
import { LabelComponentComponent } from './label-component/label-component.component';
import { CustomIconComponent } from '../custom-icon/custom-icon.component';
import { HomieBookingSuccessModal } from './modals/homie/homie-booking-success-modal/homie-booking-success-modal.component';
import { HomieBookingFailedModal } from './modals/homie/homie-booking-failed-modal/homie-booking-failed-modal.component';
import { FlightCompactCardComponent } from './flight-compact-card/flight-compact-card.component';
import { PriceInfoModalComponent } from './modals/price-info-modal/price-info-modal.component';
import { DutyfreeCustomerDetailsFormComponent } from '../dutyfree/dutyfree-customer-details-form/dutyfee-customer-details-form.component';
import { DutyfreeAllowanceSheetComponent } from '../dutyfree/dutyfree-allowance-sheet/dutyfree-allowance-sheet.component';
import { DutyfreeConfirmDialogComponent } from '../dutyfree/dutyfree-confirm-dialog/dutyfree-confirm-dialog.component';
import { DutyfreeGuestPickerComponent } from '../dutyfree/dutyfree-guest-picker/dutyfree-guest-picker.component';
import { DutyfreeOptionPickerComponent } from '../dutyfree/dutyfree-option-picker/dutyfree-option-picker.component';

import { OfferListModalComponent } from './modals/offer-list-modal/offer-list-modal.component';
import { VoucherModalComponent } from './modals/voucher-modal/voucher-modal.component';
import { SuccessPopModalComponent } from './modals/success-pop-modal/success-pop-modal.component';
import { ActivityCarouselComponent } from './home/activity-carousel/activity-carousel.component';
import { UpdateAppModalComponent } from './modals/update-app-modal/update-app-modal.component';
import { SearchModalComponent } from '../booking/hotels/components/search-modal/search-modal.component';
import { SecondaryListCardComponent } from './service-components/secondary-listing-card/secondary-list-card.component';
import { PrimaryListCardComponent } from './service-components/primary-list-card/primary-list-card.component';
import { DynamicAddressInputComponent } from './dynamic-address-input/dynamic-address-input.component';
import { AddressSelectorModalComponent } from './address-selector-modal/address-selector-modal.component';
import { AirportBannerComponent } from './airport-banner/airport-banner.component';
import { CityProductCardListComponent } from './city-product-card-list/city-product-card-list.component';
import { HotelCardListComponent } from './hotel-card-list/hotel-card-list.component';
import { LocalVoucherModalComponent } from './modals/local-voucher-modal/local-voucher-modal.component';
import { LogoCarouselComponent } from './logo-carousel/logo-carousel.component';
import { QRCodeModule } from 'angularx-qrcode';
import { ToursAndExperiencesCardComponent } from '../tours-and-experiences/shared-components/tours-and-experiences-card/tours-and-experiences-card.component';
import { ToursAndExperiencesCarouselComponent } from '../tours-and-experiences/shared-components/tours-and-experiences-carousel/tours-and-experiences-carousel.component';
import { ToursAndExperiencesTourListComponent } from '../tours-and-experiences/shared-components/tours-and-experiences-tour-list/tours-and-experiences-tour-list.component';
import { ToursAndExperiencesPassengerCountComponent } from '../tours-and-experiences/shared-components/tours-and-experiences-passenger-count/tours-and-experiences-passenger-count.component';
import { DynamicHtmlModal } from './modals/dynamic-html-modal/dynamic-html-modal';
import { LoginComponent } from './login/login.component';
import { ImportedFlightsComponent } from './modals/imported-flights/imported-flights.component';
import { SeatSelectionComponent } from './flights/seat-selection/seat-selection.component';
import { AncillaryServicesComponent } from './ancillary-services/ancillary-services.component';
import { GuestFormComponent } from './guest-form/guest-form.component';
import { DynamicFormComponentIns } from './dynamic-form-ins/dynamic-form-ins.component';
import { MobileLoginComponentComponent } from './mobile-login-component/mobile-login-component.component';
import { MemberLoginCardComponent } from './member-login-card/member-login-card.component';
import { PrimeToggleBarComponent } from './prime-toggle-bar/prime-toggle-bar.component';
import { LoginSuccessModalComponent } from './modals/login-success-modal/login-success-modal.component';
import { TravelVipSuccessModalComponent } from './modals/travel-vip-success-modal/travel-vip-success-modal.component';
import { BajajPrimeModalComponent } from './modals/bajaj-prime-modal/bajaj-prime-modal.component';
import { SavingsModalComponent } from './modals/savings-modal/savings-modal.component';
import { FlightHotelComponent } from './modals/flight-hotel/flight-hotel.component';
import { FlightSearchComponent } from './flight-search/flight-search.component';
import { HotelSearchComponent } from './hotel-search/hotel-search.component';
import { SelectListModalComponent } from './modals/select-list-modal/select-list-modal.component';
import { PassengerCountModalComponent } from './passenger-count-modal-bfl/passenger-count-modal.component';
import { PassengerFilledInfoComponent } from './passenger-filled-info/passenger-filled-info.component';
import { PassengerDetailFormV2Component } from './passenger-detail-form-v2/passenger-detail-form-v2.component';
import { GuestCounterModalComponent } from './modals/guest-counter-modal/guest-counter-modal.component';
import { BusSearchComponent } from '../booking/bus/sharedComponents/bus-search-component/bus-search-component.component';
import { BusRecentSearchComponent } from '../booking/bus/sharedComponents/bus-recent-search/bus-recent-search.component';
import { SupportContactModalComponent } from './modals/support-contact-modal/support-contact-modal.component';
import { InformationModalComponent } from './modals/information-modal/information-modal.component';
import { HotelDealsReqAlertModalComponent } from './modals/hotel-deals-req-alert-modal/hotel-deals-req-alert-modal.component';
import { SupportModalComponent } from './components/support-modal/support-modal.component';
import { TermsAndConditionsComponent } from './components/terms-and-conditions/terms-and-conditions.component';
import { PrivacyPolicyComponent } from './components/privacy-policy/privacy-policy.component';
import { SectionAccordionComponent } from './components/section-accordion/section-accordion.component';
import { EsimProductSearchComponent } from '../esim/shared/esim-product-search/esim-product-search.component';
import { BookingFilterModalComponent } from './modals/booking-filter-modal/booking-filter-modal.component';
import { UserGuestListV2Component } from './user-guest-list-v2/user-guest-list-v2.component';
import { MembershipCardComponent } from './components/membership-card/membership-card.component';
import { CalendarModalComponent } from './modals/calendar-modal/calendar-modal.component';
import { DescriptionModalComponent } from './modals/description-modal/description-modal.component';
@NgModule({
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  declarations: [
    BannerCarouselComponent,
    PassengerCountModalComponent,
    GuestCounterModalComponent,
    FreemodeCarouselComponent,
    JourneySelectPlusCardComponent,
    CircleCategoryCarouselComponent,
    EventsCardComponent,
    SimilarEventsCarouselComponent,
    ProductGridItemComponent,
    SingleBannerComponent,
    TermsModalComponent,
    TermsConditionsModalComponent,
    PrivacyPolicyModalComponent,
    SubmitSuccessComponent,
    NoBirthdayComponent,
    CouponCardComponent,
    BenefitsModalComponent,
    PriviligesModalComponent,
    UserCardComponent,
    FlightCardComponent,
    DynamicFormComponent,
    FlightArrivalComponent,
    FlightDepartureComponent,
    ProductCardListComponent,
    AutocheckoutFormComponent,
    NoDataComponent,
    FlightListCardComponent,
    CountryCodeModalComponent,
    HeroBannerComponent,
    IconButtonsGridComponent,
    ProductCarouselComponent,
    BannerGridComponent,
    SupportWidgetComponent,
    SmartHeroComponent,
    ButtonsGridComponent,
    AddVoucherComponent,
    RetailCarouselComponent,
    BookingItemComponent,
    DynamicFormModalComponent,
    SafeAreaHeaderComponent,
    GenericErrorComponent,
    NoNetworkComponent,
    ComingSoonComponent,
    MessageModalComponent,
    RetailListCardComponent,
    OfferCardComponent,
    OrderItemComponent,
    FilterModalComponent,
    BookingFilterModalComponent,
    BarcodeScannerModalComponent,
    UpgradeMembershipComponent,
    InlineGenericErrorComponent,
    CityListComponent,
    SelectCountryModalComponent,
    GenericModalComponent,
    UserGuestListComponent,
    OrderDetailsComponent,
    SmartDatePipe,
    Nl2brPipe,
    SafeHtmlPipe,
    DutyfreeCurrencyPipe,
    BookingHistoryItemComponent,
    BenefitCardComponent,
    TranslationComponent,
    CounterButtonsComponent,
    HeaderComponentComponent,
    LabelComponentComponent,
    CustomIconComponent,
    HomieBookingSuccessModal,
    HomieBookingFailedModal,
    FlightCompactCardComponent,
    OfferListModalComponent,
    VoucherModalComponent,
    SuccessPopModalComponent,
    PriceInfoModalComponent,
    ActivityCarouselComponent,
    UpdateAppModalComponent,
    AirportBannerComponent,
    CityProductCardListComponent,
    HotelCardListComponent,
    SearchModalComponent,
    SecondaryListCardComponent,
    PrimaryListCardComponent,
    DynamicAddressInputComponent,
    AddressSelectorModalComponent,
    AirportBannerComponent,
    CityProductCardListComponent,
    HotelCardListComponent,
    LocalVoucherModalComponent,
    LogoCarouselComponent,
    ToursAndExperiencesCardComponent,
    ToursAndExperiencesCarouselComponent,
    ToursAndExperiencesTourListComponent,
    ToursAndExperiencesPassengerCountComponent,
    DynamicHtmlModal,
    DutyfreeCustomerDetailsFormComponent,
    LoginComponent,
    ImportedFlightsComponent,
    SeatSelectionComponent,
    AncillaryServicesComponent,
    DutyfreeCustomerDetailsFormComponent,
    DutyfreeAllowanceSheetComponent,
    DutyfreeConfirmDialogComponent,
    DutyfreeGuestPickerComponent,
    DutyfreeOptionPickerComponent,
    GuestFormComponent,
    DynamicFormComponentIns,
    MobileLoginComponentComponent,
    MemberLoginCardComponent,
    PrimeToggleBarComponent,
    LoginSuccessModalComponent,
    TravelVipSuccessModalComponent,
    BajajPrimeModalComponent,
    SavingsModalComponent,
    FlightHotelComponent,
    FlightSearchComponent,
    HotelSearchComponent,
    PassengerFilledInfoComponent,
    PassengerDetailFormV2Component,
    GuestCounterModalComponent,
    SelectListModalComponent,
    BusSearchComponent,
    BusRecentSearchComponent,
    SupportContactModalComponent,
    InformationModalComponent,
    HotelDealsReqAlertModalComponent,
    SupportModalComponent,
    TermsAndConditionsComponent,
    PrivacyPolicyComponent,
    EsimProductSearchComponent,
    UserGuestListV2Component,
    MembershipCardComponent,
    SectionAccordionComponent,
    CalendarModalComponent,
    DescriptionModalComponent,
  ],
  imports: [
    CommonModule,
    IonicModule,
    RouterModule,
    ReactiveFormsModule,
    FormsModule,
    TranslateModule,
    QRCodeModule,
  ],
  providers: [SmartDatePipe],
  exports: [
    BannerCarouselComponent,
    PassengerCountModalComponent,
    FreemodeCarouselComponent,
    JourneySelectPlusCardComponent,
    CommonModule,
    CircleCategoryCarouselComponent,
    EventsCardComponent,
    SimilarEventsCarouselComponent,
    ProductGridItemComponent,
    SingleBannerComponent,
    TermsModalComponent,
    TermsConditionsModalComponent,
    PrivacyPolicyModalComponent,
    SubmitSuccessComponent,
    NoBirthdayComponent,
    CouponCardComponent,
    BenefitsModalComponent,
    PriviligesModalComponent,
    UserCardComponent,
    FlightCardComponent,
    DynamicFormComponent,
    FlightArrivalComponent,
    FlightDepartureComponent,
    ProductCardListComponent,
    AutocheckoutFormComponent,
    NoDataComponent,
    FlightListCardComponent,
    CountryCodeModalComponent,
    HeroBannerComponent,
    IconButtonsGridComponent,
    ProductCarouselComponent,
    BannerGridComponent,
    SupportWidgetComponent,
    SmartHeroComponent,
    ButtonsGridComponent,
    AddVoucherComponent,
    RetailCarouselComponent,
    BookingItemComponent,
    DynamicFormModalComponent,
    SafeAreaHeaderComponent,
    GenericErrorComponent,
    NoNetworkComponent,
    ComingSoonComponent,
    MessageModalComponent,
    RetailListCardComponent,
    OfferCardComponent,
    OrderItemComponent,
    FilterModalComponent,
    BookingFilterModalComponent,
    UpgradeMembershipComponent,
    InlineGenericErrorComponent,
    SelectCountryModalComponent,
    CityListComponent,
    GenericModalComponent,
    UserGuestListComponent,
    OrderDetailsComponent,
    SmartDatePipe,
    Nl2brPipe,
    SafeHtmlPipe,
    DutyfreeCurrencyPipe,
    BookingHistoryItemComponent,
    BenefitCardComponent,
    TranslateModule,
    TranslationComponent,
    CounterButtonsComponent,
    HeaderComponentComponent,
    LabelComponentComponent,
    CustomIconComponent,
    HomieBookingSuccessModal,
    HomieBookingFailedModal,
    FlightCompactCardComponent,
    OfferListModalComponent,
    VoucherModalComponent,
    SuccessPopModalComponent,
    PriceInfoModalComponent,
    ActivityCarouselComponent,
    UpdateAppModalComponent,
    AirportBannerComponent,
    CityProductCardListComponent,
    HotelCardListComponent,
    SearchModalComponent,
    SelectListModalComponent,
    SecondaryListCardComponent,
    PrimaryListCardComponent,
    DynamicAddressInputComponent,
    AddressSelectorModalComponent,
    AirportBannerComponent,
    CityProductCardListComponent,
    HotelCardListComponent,
    LocalVoucherModalComponent,
    LogoCarouselComponent,
    ToursAndExperiencesCardComponent,
    ToursAndExperiencesCarouselComponent,
    ToursAndExperiencesTourListComponent,
    ToursAndExperiencesPassengerCountComponent,
    DynamicHtmlModal,
    DutyfreeCustomerDetailsFormComponent,
    LoginComponent,
    ImportedFlightsComponent,
    SeatSelectionComponent,
    AncillaryServicesComponent,
    DutyfreeCustomerDetailsFormComponent,
    DutyfreeAllowanceSheetComponent,
    DutyfreeConfirmDialogComponent,
    DutyfreeGuestPickerComponent,
    DutyfreeOptionPickerComponent,
    GuestFormComponent,
    DynamicFormComponentIns,
    MobileLoginComponentComponent,
    MemberLoginCardComponent,
    PrimeToggleBarComponent,
    LoginSuccessModalComponent,
    TravelVipSuccessModalComponent,
    BajajPrimeModalComponent,
    SavingsModalComponent,
    FlightHotelComponent,
    FlightSearchComponent,
    HotelSearchComponent,
    PassengerFilledInfoComponent,
    PassengerDetailFormV2Component,
    BusSearchComponent,
    BusRecentSearchComponent,
    SupportContactModalComponent,
    InformationModalComponent,
    HotelDealsReqAlertModalComponent,
    SupportModalComponent,
    TermsAndConditionsComponent,
    PrivacyPolicyComponent,
    EsimProductSearchComponent,
    UserGuestListV2Component,
    MembershipCardComponent,
    SectionAccordionComponent,
    CalendarModalComponent,
    DescriptionModalComponent,
  ],
})
export class UISharedModule {}
